<template>
    <v-container>
        <v-layout>
            <v-flex xs12>
                
                <h1>Page not found!</h1>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import PreviousOrders from "./orders/PreviousOrders.vue";
import util from "@/services/util";

export default {
    components: {
        PreviousOrders
    },
    props: [
        
    ],
    data() {
        return {
            
        };
    },
    computed: {
        
    },
    methods: {
        
    },
    created(){
        
    }
};
</script>

<style>
    
</style>